import React, { useState, useEffect } from "react";

import { sGetRaw, sSetRaw } from "../lib/scopedStorage";
const COOKIE_KEY = "oe_cookie_consent";
const FONT = "'Inter','Avenir Next','Century Gothic',sans-serif";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!sGetRaw(COOKIE_KEY)) setVisible(true);
    } catch { /* storage blocked */ }
  }, []);

  const dismiss = () => {
    try { sSetRaw(COOKIE_KEY, "accepted"); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 99999,
      background: "#1a1f2e", borderTop: "1px solid #2d3748",
      padding: "14px 24px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      flexWrap: "wrap", gap: 12,
      fontFamily: FONT,
    }}>
      <p style={{ margin: 0, fontSize: 13, color: "#9ca3b0", lineHeight: 1.5, maxWidth: 680 }}>
        We use cookies and session storage for authentication and to keep you signed in.
        We don't use tracking or advertising cookies.{" "}
        <a href="#/privacy" style={{ color: "#4fd1c5", textDecoration: "none" }}>
          Privacy Policy
        </a>
      </p>
      <button
        onClick={dismiss}
        style={{
          background: "#4fd1c5", border: "none", color: "#0f1117",
          fontWeight: 700, fontSize: 12, padding: "8px 20px",
          borderRadius: 6, cursor: "pointer", fontFamily: FONT,
          whiteSpace: "nowrap", flexShrink: 0,
        }}
      >
        Got it
      </button>
    </div>
  );
}
